import * as CONSTANTS from "../../Constants/index"
//import { IAddressTable } from '../../Interfaces/IAddressTable'

type PaginationState = {
  skip: number,
  queryPageIndex: number,
  queryPageSize: number,
  totalCount: number,
  //sort: SortingRule<any>[]
}

type PaginationAction = {
  type: string
  payload: number
  //sortInfo: SortingRule<any>[]
}

export const initialState = {
  skip: 0,
  queryPageIndex: 1,
  queryPageSize: 10,
  totalCount: 0,
  //sort:[]
}

export const reducer = (state: PaginationState, action: PaginationAction) => {
  switch (action.type) {
    case CONSTANTS.PAGE_CHANGED:
      const skip = (action.payload - 1) * state.queryPageSize;
      return {
        skip: skip,
        queryPageIndex: action.payload,
        queryPageSize: state.queryPageSize,
        totalCount: state.totalCount,
        //sort:state.sort
      };
    case CONSTANTS.PAGE_SIZE_CHANGED:
      return {
        skip: state.skip,
        queryPageIndex: state.queryPageIndex,
        queryPageSize: action.payload,
        totalCount: state.totalCount,
        //sort: state.sort
      };
    case CONSTANTS.TOTAL_COUNT_CHANGED:
      {
        let lastIndex = Math.ceil(action.payload / state.queryPageSize);
        let queryPageIndex = state.queryPageIndex > lastIndex ? lastIndex : state.queryPageIndex;
        let skip = (queryPageIndex - 1) * state.queryPageSize;
        return {
          skip: skip,
          queryPageIndex: queryPageIndex,
          queryPageSize: state.queryPageSize,
          totalCount: action.payload,
          //sort: state.sort
        };
      }
    case CONSTANTS.PAGE_SORT:
      return {
        skip: state.skip,
        queryPageIndex: state.queryPageIndex,
        queryPageSize: state.queryPageSize,
        totalCount: state.totalCount,
        //sort: action.sortInfo

      };
    case CONSTANTS.SEARCH_PAGE_RESET:
      return {
        skip: 0,//state.skip,
        queryPageIndex: 1, //state.queryPageIndex,
        queryPageSize: state.queryPageSize,
        totalCount: action.payload // state.totalCount,
      };
    case CONSTANTS.PAGE_INITIAL_STATE:
      return {
        ...initialState
      }
    default:
      return state
  }
}